import { InlineEditor } from 'components/shared/InlineEditor'
import Input from 'shared-web/src/components/Input'
import Modal from 'components/Modal'
import { captureExceptions } from 'utils/SentryHelpers'
import { makeOnCommandEnterKeyHandler } from 'utils/FormHelpers'
import MakeInputChangeHandler from 'mixins/MakeInputChangeHandler'

import 'styles/components/reply/ComposeReplyModal.styl'

const ComposeReplyModal = React.createClass({
  displayName: 'ComposeReplyModal',

  mixins: [MakeInputChangeHandler],

  getInitialState() {
    let initialState
    if (this.props.reply && !this.props.duplicate) {
      initialState = {
        name: this.props.reply.name,
        text: this.props.reply.text
      }
    } else {
      initialState = {
        name: '',
        text: this.props.populatedText || (this.props.reply != null ? this.props.reply.text : undefined) || ''
      }
    }

    initialState.isHandlingCreation = !this.props.reply ||
      (this.props.duplicate && this.props.reply)
    return initialState
  },

  componentDidMount() {
    return this.cacheNamesTaken(this.props)
  },

  componentWillReceiveProps(nextProps) {
    return this.cacheNamesTaken(nextProps)
  },

  // optimization to not do this on render everything
  cacheNamesTaken(props) {
    return this.setState({ replyNamesTaken: _.map(props.replyById, 'name') })
  },

  hasTextChanged() {
    return this.state.text !== (this.props.reply != null ? this.props.reply.text : undefined)
  },

  hasChanged() {
    return this.hasNameChanged() || this.hasTextChanged()
  },

  isNameValid() {
    return this.state.name && !this.isNameTaken()
  },

  hasNameChanged() {
    return this.state.name !== (this.props.reply != null ? this.props.reply.name : undefined)
  },

  getNameInputError() {
    if (this.isNameTaken()) {
      return 'Sorry, name is taken'
    }
  },

  isNameTaken() {
    if (this.state.name) {
      // check if name is taken on reply creation or edits of an existing reply when the name has changed.
      if (this.state.isHandlingCreation || (!this.state.isHandlingCreation && this.hasNameChanged())) {
        return _.indexOf(this.state.replyNamesTaken, this.state.name) >= 0
      } else {
        return false
      }
    } else {
      return false
    }
  },

  canSave() {
    return this.hasChanged() && this.isNameValid() && this.state.text
  },

  tryRunOnSave() {
    const { onSave } = this.props
    onSave && onSave()
  },

  tryRunOnClose() {
    const { onClose } = this.props
    onClose && onClose()
  },

  onSaveClick() {
    if (this.canSave()) {
      if (!this.state.isHandlingCreation) {
        this.app.actions.SavedReplyActions.updateReply(this.props.reply.id, { name: this.state.name, text: this.state.text }, true)
          .then(this.tryRunOnSave)
      } else {
        this.app.actions.SavedReplyActions.createReply({ name: this.state.name, text: this.state.text })
          .then(this.tryRunOnSave)
      }
    }

    this.tryRunOnClose()
  },


  render() {
    return (
      <div
        className="ComposeReplyModal"
        onKeyDown={makeOnCommandEnterKeyHandler(this.onSaveClick)}>
        <div className="modal-title">
          {!this.state.isHandlingCreation ? 'Edit This Reply' : 'Create New Saved Reply'}
        </div>
        <Input
          type="text"
          autoFocus={true}
          placeholder="Name (internal only)"
          valueLink={{ value: this.state.name, requestChange: this.makeInputChangeHandler('name') }}
          isValid={this.isNameValid()}
          errorLabel={this.getNameInputError()} />
        <Input
          className="ComposeReplyModal--TextArea"
          inputComponent={InlineEditor}
          options={{ placeholder: { text: 'What your visitor sees goes here' }}}
          isSavedReplyEditor={true}
          onChange={this.makeInputChangeHandler('text')}
          isValid={this.state.text}
          text={this.state.text} />
        {// TODO add tag functionality
        //React.DOM.div { className: 'tags' }
        <div className="actions">
          <div className="cancel" onClick={this.props.onClose}>
            Cancel
          </div>
          <button
            className="color-teal"
            onClick={this.onSaveClick}
            disabled={!this.canSave()}>
            SAVE
          </button>
        </div>}
      </div>
    )
  }
})


const ComposeReplyModalContainer = Marty.createContainer(ComposeReplyModal, {
  listenTo: ['stores.SavedReplyStore'],
  fetch: {
    replyById() {
      return this.app.stores.SavedReplyStore.fetchReplyList()
    },

    reply() {
      if (this.props.params.replyId && (this.props.params.replyId !== 'new')) {
        return this.app.stores.SavedReplyStore.fetchReply(this.props.params.replyId)
      } else {
        return false
      }
    }
  },

  pending() {
    return (
      <div className="ComposeReplyModal">
        <div className="loader-rotating" />
      </div>
    )
  },

  failed(errors) {
    captureExceptions(errors)
    return <div />
  }
})

const ModalWrapper = React.createClass({

  render() {
    return (
      <Modal onClose={this.props.onClose} ignoreCloseOnClickOutside={true}>
        <ComposeReplyModalContainer {...this.props} />
      </Modal>
    )
  }
})

export default ModalWrapper



// WEBPACK FOOTER //
// ./src/scripts/components/reply/ComposeReplyModal.js